import { type Registry as Services, service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { SupportedCurrencies } from 'frontend-utils/utils/constants/currency-mapping-constants';
import type { FavouriteCurrency } from 'lumen/models';
import { CURRENCY_TRANSLATION_MAPPING } from 'lumen/utils/constants/currency-translation-constants';

export default class Currency extends Model {
  [Type] = 'currency' as const;

  @belongsTo('favourite-currency', { async: false, inverse: 'currency' })
  declare favourite: FavouriteCurrency | null;

  @attr('string') declare code: SupportedCurrencies;
  @attr('number') declare referenceValue: number;
  @attr('string') declare symbol: string;

  @service declare intl: Services['intl'];

  get isFavourite(): boolean {
    return Boolean(this.favourite);
  }

  get name(): string {
    if (!CURRENCY_TRANSLATION_MAPPING[this.code]) {
      return this.code;
    }

    return this.intl.t(CURRENCY_TRANSLATION_MAPPING[this.code]);
  }
}
